import { useState, useCallback } from 'react';

import CookieService from '../services/cookie-service';
import LogService from '../services/log-service';

const useCookie = (key) => {
  const currentValue = CookieService.getCookieValue(key);
  const [cookieValue, setCookieValue] = useState(currentValue);

  const updateCookieValue = useCallback(
    (newValue) => {
      setCookieValue(newValue);
      try {
        CookieService.setCookieValueWithPathAndDomain(key, newValue);
      } catch (e) {
        LogService.logWarning('Unable to save cookie value', {
          key,
          value: newValue,
          e,
        });
      }
    },
    [key, setCookieValue],
  );

  return {
    cookieValue,
    setCookieValue: updateCookieValue,
  };
};

export default useCookie;
